"use client";

import React from "react";
import { useTtsVoiceSelect } from "@/components/common/voice-selector/hooks/use-tts-voice-select";
import VoiceSelectorBase from "@/components/common/voice-selector/selectors/base/voice-selector-base";

const TtsVoiceSelector = () => {
  const { handleTtsVoiceModelClick, scrollUpdate, isLoading, models } =
    useTtsVoiceSelect();
  return (
    <VoiceSelectorBase
      isLoading={isLoading}
      filteredVoiceList={models}
      handleVoiceModelClick={handleTtsVoiceModelClick}
      scrollUpdate={scrollUpdate}
      needsEmptySpace={false}
    />
  );
};

export default TtsVoiceSelector;
